import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { MapFilterService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class MapFilterBloc extends Bloc<MapFilterService['mapFilterControllerGetOne']> {
    public constructor(service: MapFilterService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.mapFilterControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
